var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "M1.005 17.982c0-3.54 2.957-6.41 9-6.41s9 2.87 9 6.41c0 .563-.41 1.02-.918 1.02H1.923c-.507 0-.918-.457-.918-1.02ZM13.38 4.376a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Z"
  })));
};
export default SvgProfile;